import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=5234bd70&scoped=true"
import script from "./UploadPhoto.vue?vue&type=script&lang=js"
export * from "./UploadPhoto.vue?vue&type=script&lang=js"
import style0 from "./UploadPhoto.vue?vue&type=style&index=0&id=5234bd70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5234bd70",
  null
  
)

export default component.exports